import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useDeleteSection = () => {
  const { authHeader } = useAuth();

  return useMutation((sectionId: number) => {
    return axios.delete(`${env.verifyServiceUrl}individual/section/${sectionId}/`, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
